import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsModule } from 'src/app/main/shared/constants/constants.module';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';
import { environment } from 'src/environments/environment';
import { RainfallActualMapConstants } from '../rainfall-actual/rainfall-actual-map/rainfall-actual-map-constants';

@Injectable({
  providedIn: 'root'
})
export class RainfallActualQcDataService {

  constructor(private http: HttpClient, private errorHandler: HttperrorhandlerService, private utilsShared: UtilsSharedModule, private constants: ConstantsModule) { }

  getLocationList(postData) {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + "rf/aggregated", postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getRFActualTableData(postData): Observable<any> {
    // postData.format = 'DAILY';
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + "rf/aggregated", postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getHeirarchy(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  fetchSource(countryUUID: any, stateUUID: any): Observable<any> {
    const heatMapUrl = 'rf/getSourcesForState/' + countryUUID + '/' + stateUUID;
    return this.http.get<any>(environment.url.OBSERVED_API_URL + heatMapUrl).pipe(
      catchError(this.errorHandler.handleError('Source Requested', []))
    );
  }

  getHeatMap(url, postData) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.post(url, postData).subscribe(
        data => {
          resolve(data);
        });
    });
    return dataPromise;
  }

  post(postData): Observable<any> {
    let projURL = environment.url.HEATWAVE_STAGING_API_URL + "rf/aggregated";
    // let projURL = "http://192.168.12.159:9000/api/rf/aggregated";
    return this.http.post<any>(projURL, postData);
  }

  updateStationsData(postData) {
    let url = environment.url.OBSERVED_API_URL + "rf/updateStationLevelData";
    // let url = "http://192.168.12.159:8080/api/rf/updateStationLevelData";
    return this.http.post<any>(url, postData)
  }

  moveStationDataToValidState(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "rf/moveStationDataIntoValidationState";
    // let url = "http://192.168.12.159:9000/api/rf/moveStationDataIntoValidationState";
    return this.http.post<any>(url, postData)
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    let latlongs = [];
    latlongs.push(data['southWest']['latitude']);
    latlongs.push(data['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(data['northEast']['latitude']);
    latlongs.push(data['northEast']['longitude']);
    imageBounds.push(latlongs);
    obj['bounds'] = imageBounds;
    return obj;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  setYTD(data: object): Object {
    if (!data || !data['MAX'] || data['MAX'] == 0) {
      return;
    }
    const ytd = { required: true };
    ytd['value'] = data['MAX'].toString().substr(0, 4);
    Object.assign(ytd, data);
    // console.log("this.ytd  :::",this.ytd);
    return ytd;
  }

  setMinMax(range: object): any {
    const arr = [];
    if (
      !range ||
      !range['MAX'] ||
      range['MAX'] == 0 ||
      !range['MIN'] ||
      range['MIN'] == 0
    ) {
      const minDate = new Date();
      const maxDate = new Date();
      arr.push(minDate);
      arr.push(maxDate);
      return arr;
    }
    // const minDate = this.utilsShared.getDateObjectFromModelDate(
    //   (range['MIN']).toString()
    // );
    // let maxDate = this.utilsShared.getDateObjectFromModelDate(
    //   range['MAX'].toString()
    // );
    // maxDate = maxDate.getTime() > new Date().getTime() ? new Date() : maxDate;
    let today = new Date();
    let minDate = new Date(today.getFullYear() - 1, 10, 17);
    let maxDate = new Date(today); // Clone today's date
    maxDate.setDate(today.getDate() - 1);
    arr.push(minDate);
    arr.push(maxDate);
    return arr;
  }

  getQueryParamsForRFActual(params) {
    const defDate = this.utilsShared.getModelDateWithDateFormat(
      new Date(Date.now() - 0 * 24 * 60 * 60 * 1000),
      params['format']
    );
    const bound1 = {
      MIN: defDate,
      MAX: defDate,
    };
    const arr = this.setMinMax(bound1);
    const ytd = this.setYTD(bound1);
    const minDate = arr[0];
    const maxDate = arr[1];
    const Obj = this.utilsShared.setWaterYear(maxDate, minDate);
    console.log("OBJJ::",Obj);
    

    const sDate = this.utilsShared.getModelDateWithDateFormat(
      Obj['defaultSDate'],
      this.constants.EVENTGEN_DAY
    );
    const eDate = this.utilsShared.getModelDateWithDateFormat(
      Obj['defaultEDate'],
      this.constants.EVENTGEN_DAY
    );
    return { sDate: sDate, eDate: eDate };
  }

  getPostDataForSensor(params,source) {
    let stateUUID: any;
    if (params.locType == 'DISTRICT') {
      let location = params.location.split('&')[1]
      stateUUID = location.split('##')[1]
    }
    let postData = {
      "sDate": params.sDate,
      "eDate": params.eDate,
      "pUUID": '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      "pType": 'COUNTRY',
      "format": this.getFormat(params.format),
      "cType": "RAINFALL",
      "pEUUID": '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      "classification": [
        "ACTUAL"
      ],
      "src": source,
      "aggr": params.aggr,
      "includeAllLoc": true
    }

    return postData
  }

  getFormat(format) {
    console.log(format, "format123");
    if (format == 'yyyyMMdd') {
      return 'DAILY'
    } else if (format == 'yyyyMM') {
      return 'MONTHLY'
    } else if (format == 'yyyy') {
      return 'YEARLY'
    } else {
      return 'HOURLY'
    }
  }

  getHeatMapPostData(queryParams) {
    let stateUUID: any
    if (queryParams.locType == 'DISTRICT') {
      let location = queryParams.location.split('&')[1]
      stateUUID = location.split('##')[1]
    }
    let postData = {
      "pUUID": queryParams.locType == 'DISTRICT' ? stateUUID : queryParams.pUUID,
      "pType": queryParams.locType == 'DISTRICT' ? 'STATE' : queryParams.locType,
      "cType": "BLOCK",
      "format": this.getFormat(queryParams.format),
      "src": queryParams.source,
      "sDate": queryParams.sDate,
      "eDate": queryParams.eDate,
      "aggr": queryParams.aggr,
      "pEUUID": queryParams.locType == 'DISTRICT' ? stateUUID : queryParams.pUUID,
      "classification": [
        "ACTUAL"
      ],
      "view": "admin"
    }

    return postData
  }

  getLegendData(queryParams) {
    let startDate = queryParams['sDate'] || this.utilsShared.getModelDateFromDate(new Date());
    let endDate = queryParams['eDate'] || this.utilsShared.getModelDateFromDate(new Date());
    let format = queryParams['format'] || this.constants.DATEPICKER_DATE_FORMAT.DAY;
    let noOfDays = 1 + this.utilsShared.getNumberOfDaysBetweenTwoModelDates(startDate, endDate, format);
    if (noOfDays <= 30 || queryParams['format'] == 'HOURLY') return RainfallActualMapConstants.RFACTUAL_LEGEND.CURRENT_DATE;
    // return RainfallActualMapConstants.RFACTUAL_LEGEND.CURRENT_DATE;
    if (noOfDays > 30) return RainfallActualMapConstants.RFACTUAL_LEGEND.PAST_DATE;
  }

  getLegendType(queryParams) {
    let startDate = queryParams['sDate'] || this.utilsShared.getModelDateFromDate(new Date());
    let endDate = queryParams['eDate'] || this.utilsShared.getModelDateFromDate(new Date());
    let format = queryParams['format'] || this.constants.DATEPICKER_DATE_FORMAT.DAY;
    let noOfDays = 1 + this.utilsShared.getNumberOfDaysBetweenTwoModelDates(startDate, endDate, format);
    if (noOfDays <= 30 || queryParams['format'] == 'HOURLY') return 'CURRENT_DATE';
    // return 'CURRENT_DATE';
    if (noOfDays > 30) return 'PAST_DATE';
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }
}
